import Vue from 'vue';
import Vuex from 'vuex';
import App from './src/search/App.vue';
import { BlueSearch, store } from '@bluemodus/blue-search';
import '@bluemodus/blue-search/dist/style.css';

window.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('#searchApp');
  const options = { ...el.dataset };

  Vue.config.productionTip = false;

  Vue.use(Vuex);
  Vue.use(BlueSearch, options);

  new Vue({
    store: new Vuex.Store(store),
    render: h => h(App),
  }).$mount(el);
});
